export var ClassNames;
(function (ClassNames) {
  ClassNames["container"] = "live-chat-loader-placeholder";
})(ClassNames || (ClassNames = {}));